<script lang="ts">
  import { type EditableMetadata, type Image } from "bildebanken-model";
  import type { StringValuedKeys } from "utils/typescript";
  import EditMediaCreatedOn from "./EditMediaCreatedOn.svelte";
  import type { EditImageActor, EditImageState } from "./editImageMachine";
  import { fieldMissingForCurrentImage, isRequiredField, updateField } from "./editImageMachine";
  import EditAltText from "./EditAltText.svelte";
  import EditImageType from "./EditImageType.svelte";
  export let state: EditImageState;
  export let service: EditImageActor;
  export let image: Image;

  function onTextFieldInput(name: StringValuedKeys<EditableMetadata>) {
    return function (this: HTMLInputElement) {
      updateField(service, name, this.value);
    };
  }

  $: titleMissing = isRequiredField(state, "title") && fieldMissingForCurrentImage(state, "title");
  $: imageTypeRequired = isRequiredField(state, "digitalSourceType");
  $: imageTypeRequiredMissingForCurrentImage = fieldMissingForCurrentImage(
    state,
    "digitalSourceType",
  );

  let altTextAltered = false;
  $: altTextRequired = isRequiredField(state, "altText");

  function altTextUpdate(text: string) {
    altTextAltered = true;
    updateField(service, "altText", text);
  }
</script>

<label>
  Tittel
  <span class={isRequiredField(state, "title") ? "" : "hidden"}>*</span>
  <input
    class="org-input"
    type="text"
    value={image.metadata.title || ""}
    placeholder="Objektets navn"
    on:input={onTextFieldInput("title")}
    aria-invalid={titleMissing}
  />
  <span class="org-warning">Tittel må fylles ut</span>
</label>
<label>
  Beskrivelse
  <span class={isRequiredField(state, "description") ? "" : "hidden"}>*</span>
  <textarea
    class="org-input"
    rows="2"
    value={image.metadata.description || ""}
    placeholder="Beskriv hvem, hva og hvorfor til Bildebanken"
    on:input={onTextFieldInput("description")}
  />
</label>
<EditAltText
  {altTextRequired}
  altText={image.metadata.altText ?? undefined}
  editingSingleImage={state.matches("Editing.Single")}
  {altTextUpdate}
  {image}
/>

<EditMediaCreatedOn {service} {image} />

<EditImageType {service} {imageTypeRequired} {imageTypeRequiredMissingForCurrentImage} {image} />

<style>
  .hidden {
    display: none;
  }
  label {
    display: block;
    margin-bottom: var(--org-medium);
    position: relative;
  }
</style>
